import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuItem from './menuItem'
import MenuTree from './menuTree'
import { withRouter } from 'react-router-dom';

import { carregarUsuario } from '../../auth/authActions';

class Menu extends Component {

	state = {
		acessoAberto: null,
		cadastroAberto: null
	}

	constructor(props) {
		super(props);

		let idInterval = setInterval(() => {
			if (this.props.usuario) {
				this.props.carregarUsuario();
				clearInterval(idInterval);
			}
		}, 2000);
	}

	render() {

		const usuarioCarregado = this.props.usuarioCarregado;

		let selecionado = '';
		if (this.props.location && this.props.location.pathname) {
			selecionado = this.props.location.pathname;
		}

		if (selecionado != '/' 
			&& this.state.acessoAberto == null
			&& this.state.cadastroAberto == null
		) {
			if (selecionado == '/usuarioPerfil' || selecionado == '/usuario') {
				this.setState({
					...this.state,
					acessoAberto: true
				});
			} else if (selecionado == '/empresa' 
				|| selecionado == '/fornecedor' 
				|| selecionado == '/veiculo' 
				|| selecionado == '/unidadeMedida' 
				|| selecionado == '/produto'
				|| selecionado == '/cliente'
				|| selecionado == '/analisePreco'
				|| selecionado == '/planoConta'
				|| selecionado == '/centroCusto'
			) {
				this.setState({
					...this.state,
					cadastroAberto: true
				});
			}
		}		
		
		return (
			<nav className="mt-2">

				{usuarioCarregado &&			    
				<ul className="nav nav-pills nav-sidebar flex-column nav-flat nav-compact" data-widget="treeview" role="menu" data-accordion="false">
					<MenuItem path='/' label='Dashboard' icon='fas fa-tachometer-alt' active={selecionado == '/'} />
					
					{(this.props.getPermissao('cadastro_perfil') || this.props.getPermissao('cadastro_usuario')) &&
					<MenuTree icon={'fas fa-user-lock'} label={'Acesso'}
						display={this.state.acessoAberto}
						onClick={() =>
							this.setState({
								...this.state,
								acessoAberto: !this.state.acessoAberto,
							})
						} >
						{this.props.getPermissao('cadastro_perfil') &&
						<MenuItem submenu path='usuarioPerfil' label='Perfil' icon='fas fa-list' active={selecionado == '/usuarioPerfil'} />}
						{this.props.getPermissao('cadastro_usuario') &&
						<MenuItem submenu path='usuario' label='Usuário' icon='fas fa-id-card-alt' active={selecionado == '/usuario'} />}
					</MenuTree>}

					{(this.props.getPermissao('cadastro_fornecedor')
						|| this.props.getPermissao('cadastro_veiculo')
						|| this.props.getPermissao('cadastro_unidade_medida')
						|| this.props.getPermissao('cadastro_produto')
						|| this.props.getPermissao('cadastro_cliente')
						|| this.props.getPermissao('cadastro_plano_conta')
						|| this.props.getPermissao('cadastro_centro_custo')
					) &&
					<MenuTree icon={'fas fa-cogs'} label={'Cadastro'}
						display={this.state.cadastroAberto}
						onClick={() =>
							this.setState({
								...this.state,
								cadastroAberto: !this.state.cadastroAberto,
							})
						} >
						{this.props.getPermissao('cadastro_fornecedor') &&
						<MenuItem submenu path='fornecedor' label='Fornecedor' icon='fas fa-users' active={selecionado == '/fornecedor'} />}
						{this.props.getPermissao('cadastro_veiculo') &&
						<MenuItem submenu path='veiculo' label='Veículo' icon='fas fa-truck' active={selecionado == '/veiculo'} />}
						{this.props.getPermissao('cadastro_unidade_medida') &&
						<MenuItem submenu path='unidadeMedida' label='Unidade de Medida' icon='fas fa-ruler' active={selecionado == '/unidadeMedida'} />}
						{this.props.getPermissao('cadastro_produto') &&
						<MenuItem submenu path='produto' label='Produto' icon='fas fa-bars' active={selecionado == '/produto'} />}
						{this.props.getPermissao('cadastro_cliente') &&
						<MenuItem submenu path='cliente' label='Cliente' icon='fas fa-user-tie' active={selecionado == '/cliente'} />}
						{this.props.getPermissao('cadastro_analise_preco') &&
						<MenuItem submenu path='analisePreco' label='Preço das Análises' icon='fas fa-comment-dollar' active={selecionado == '/analisePreco'} />}
						{this.props.getPermissao('cadastro_plano_conta') &&
						<MenuItem submenu path='planoConta' label='Plano de Contas' icon='fas fa-coins' active={selecionado == '/planoConta'} />}
						{this.props.getPermissao('cadastro_centro_custo') &&
						<MenuItem submenu path='centroCusto' label='Centro de Custo' icon='fas fa-funnel-dollar' active={selecionado == '/centroCusto'} />}
					</MenuTree>}

					{this.props.getPermissao('coleta') &&
					<MenuItem path='coleta' label='Coletas' icon='fas fa-clipboard-list' active={selecionado == '/coleta'} />}

					{this.props.getPermissao('aplicacao') &&
					<MenuItem path='aplicacao' label='Aplicações' icon='fas fa-seedling' active={selecionado == '/aplicacao'} />}

					{this.props.getPermissao('abastecimento') &&
					<MenuItem path='abastecimento' label='Abastecimentos' icon='fas fa-gas-pump' active={selecionado == '/abastecimento'} />}

					{this.props.getPermissao('agenda') &&
					<MenuItem path='agenda' label='Agenda' icon='fas fa-calendar-alt' active={selecionado == '/agenda'} />}

					{this.props.getPermissao('solicitacao') &&
					<MenuItem path='solicitacao' label='Solicitação' icon='fas fa-list-ol' active={selecionado == '/solicitacao'} />}

					{this.props.getPermissao('ordem_producao') &&
					<MenuItem path='producaoProgramacao' label='Programar Produção' icon='far fa-calendar' active={selecionado == '/producaoProgramacao'} />}

					{this.props.getPermissao('ordem_producao') &&
					<MenuItem path='producao' label='Produção' icon='far fa-play-circle' active={selecionado == '/producao'} />}

					{this.props.getPermissao('entregas') &&
					<MenuItem path='entrega' label='Entrega' icon='fas fa-truck' active={selecionado == '/entrega'} />}
				</ul>}
			</nav>
		);
	}
}

const mapStateToProps = state => ({
	usuario: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	getPermissao: state.auth.getPermissao
});
const mapDispatchToProps = dispatch => bindActionCreators({ carregarUsuario }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
